// React
import React, { useEffect, useState, useCallback } from "react";
import s from "../AgencyModal/AgencyModal.module.css";
// Assets
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
// MaterialUi
import CircularProgress from "@mui/material/CircularProgress"
import Grid from "@mui/material/Grid"
import Modal from "@mui/material/Modal"
import TableContainer from "@mui/material/TableContainer"
import Table from "@mui/material/Table"
import TableHead from "@mui/material/TableHead"
import TableBody from "@mui/material/TableBody"
import TableRow from "@mui/material/TableRow"
import TableCell from "@mui/material/TableCell"
import Pagination from "@mui/material/Pagination"
import Button from "@mui/material/Button"
import CloseIcon from "@mui/icons-material/Close";
// Components imports
import CreateRaffle from "../../Pages/Sorteos/Create";
// Service imports
import deliveryServices from "../../../api/delivery/DeliveryService";
import raffleService from "../../../api/raffles/RafflesService";

const cellStyles = {
  fontFamily: "Roboto, sans-serif",
  fontSize: "0.9rem",
  fontWeight: "400",
  borderBottom: "1px solid rgba(0, 0, 0, 0.455)",
  cursor: "pointer",
};

// =========================== | PRODUCTOS MODAL | =============================

const ProductosModal = ({
  open,
  setOpen,
  data,
  game,
  selectProduct,
  setDetail,
}) => {
  // Section: Utils Hooks
  const { t } = useTranslation();
  const dispatch = useDispatch();

  // Section: Reduc States
  const { textColor } = useSelector((state) => state.local);

  // Section: States
  const [items, setItems] = useState([]);
  const [create, setCreate] = useState(false);
  //paginado
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  // Section: Handlers
  const handlePaginate = (e, v) => {
    setPage(v);
  };

  // Section: Callback
  const getRaffles = useCallback(() => {
    setLoading(true);
    if (data.type === "proveedor") {
      let date = new Date();
      let payloadDate = date.toISOString();
      if (game?.mode?.id === 2) {
        raffleService
          .getFilteredRaffles(
            game?.game?.id,
            game?.mode?.id,
            page,
            false,
            dispatch,
          )
          .then((res) => {
            setItems(res.content);
            setTotalPages(res.totalPages);
          })
          .then(() => setLoading(false))
          .catch((e) => console.log(e));
      } else {
        raffleService
          .getFilteredRaffles(
            game?.game?.id,
            game?.mode?.id,
            page,
            payloadDate,
            dispatch,
          )
          .then((res) => {
            setItems(res.content);
            setTotalPages(res.totalPages);
          })
          .then(() => setLoading(false))
          .catch((e) => console.log(e));
      }
    } else {
      deliveryServices
        .getProductsByAgencyId(data.number, page, game?.game?.id)
        .then((res) => {
          if (!res.empty) {
            setItems(res.content);
            setTotalPages(res.totalPages);
          } else {
            throw new Error("There is an error");
          }
        })
        .then(() => setLoading(false))
        .catch((error) => {
          setLoading(false);
          console.log(error);
        });
    }
  }, [data.number, data.type, dispatch, game?.game?.id, game?.mode?.id, page]);

  // Section: Effect
  useEffect(() => {
    getRaffles();
  }, [getRaffles, page]);

  // Section: JSX
  return (
    <Modal open={open} onClose={() => setOpen(false)}>
      <Grid container>
        <Grid
          xs={12}
          md={8}
          lg={4.5}
          item
          container
          className={s.boxModal}
          sx={{ bgcolor: "#EEEEEE" }}
        >
          <Grid
            container
            item
            xs={12}
            sx={{ display: "flex", justifyContent: "center" }}
          >
            <Grid item xs={11} className={s.exit}>
              <div className={s.titleModal}>
                <p>{t("products")}</p>
                <span>{t("select")}</span>
              </div>
              <CloseIcon
                onClick={() => setOpen(false)}
                className={s.exitIcon}
                sx={{ color: "primary.dark" }}
              />
            </Grid>

            {create ? (
              <CreateRaffle
                setDetail={setDetail}
                setOpen={setOpen}
                setRaffleSelected={selectProduct}
                modal={true}
                setCreate={setCreate}
                callAllRaffles={getRaffles}
              />
            ) : loading ? (
              <Grid item xs={12} className={s.loader}>
                <CircularProgress />
              </Grid>
            ) : items?.length ? (
              <Grid item container xs={11} className={s.data}>
                <TableContainer className={s.tableContainer}>
                  <Table stickyHeader>
                    <TableHead>
                      {data.type === "proveedor" ? (
                        <>
                          <TableRow>
                            <TableCell
                              sx={{
                                "&:hover": { cursor: "pointer" },
                                backgroundColor: "primary.main",
                                color: textColor,
                                fontSize: ".9rem",
                                fontWeight: 500,
                                fontFamily: "Roboto, sans-Serif",
                              }}
                            >
                              {t("game")}
                            </TableCell>
                            <TableCell
                              sx={{
                                "&:hover": { cursor: "pointer" },
                                backgroundColor: "primary.main",
                                color: textColor,
                                fontSize: ".9rem",
                                fontWeight: 500,
                                fontFamily: "Roboto, sans-Serif",
                              }}
                            >{`${t("drawNumber")}/${t("serie")}`}</TableCell>
                            <TableCell
                              sx={{
                                "&:hover": { cursor: "pointer" },
                                backgroundColor: "primary.main",
                                color: textColor,
                                fontSize: ".9rem",
                                fontWeight: 500,
                                fontFamily: "Roboto, sans-Serif",
                              }}
                            >
                              {t("drawDate")}
                            </TableCell>
                          </TableRow>
                        </>
                      ) : (
                        <>
                          <TableRow>
                            <TableCell
                              sx={{
                                "&:hover": { cursor: "pointer" },
                                backgroundColor: "primary.main",
                                color: textColor,
                                fontSize: ".9rem",
                                fontWeight: 500,
                                fontFamily: "Roboto, sans-Serif",
                              }}
                            >
                              {t("game")}
                            </TableCell>
                            <TableCell
                              sx={{
                                "&:hover": { cursor: "pointer" },
                                backgroundColor: "primary.main",
                                color: textColor,
                                fontSize: ".9rem",
                                fontWeight: 500,
                                fontFamily: "Roboto, sans-Serif",
                              }}
                            >
                              {t("totalCoupons")}
                            </TableCell>
                            <TableCell
                              sx={{
                                "&:hover": { cursor: "pointer" },
                                backgroundColor: "primary.main",
                                color: textColor,
                                fontSize: ".9rem",
                                fontWeight: 500,
                                fontFamily: "Roboto, sans-Serif",
                              }}
                            >
                              {t("coupons")}
                            </TableCell>
                            <TableCell
                              sx={{
                                "&:hover": { cursor: "pointer" },
                                backgroundColor: "primary.main",
                                color: textColor,
                                fontSize: ".9rem",
                                fontWeight: 500,
                                fontFamily: "Roboto, sans-Serif",
                              }}
                            >
                              {t("drawNumber")}
                            </TableCell>
                            <TableCell
                              sx={{
                                "&:hover": { cursor: "pointer" },
                                backgroundColor: "primary.main",
                                color: textColor,
                                fontSize: ".9rem",
                                fontWeight: 500,
                                fontFamily: "Roboto, sans-Serif",
                              }}
                            >
                              {t("drawDate")}
                            </TableCell>
                          </TableRow>
                        </>
                      )}
                    </TableHead>
                    <TableBody>
                      {items.map((item, i) => {
                        let date =
                          item?.raffle?.raffleDate
                            ?.split("T")[0]
                            ?.split("-")
                            .reverse()
                            .join("-") ||
                          item?.raffleDate
                            ?.split("T")[0]
                            ?.split("-")
                            .reverse()
                            .join("-");
                        return (
                          <React.Fragment key={item.id}>
                            <TableRow
                              sx={{
                                "&:hover": {
                                  backgroundColor: "secondary.light",
                                },
                              }}
                              onClick={() => {
                                if (data.type === "proveedor") {
                                  selectProduct(item);
                                  setDetail((prev) => ({
                                    ...prev,
                                    raffleId: item?.id,
                                  }));
                                } else {
                                  selectProduct({
                                    ...item?.raffle,
                                    nroCouponFrom: item?.nroCouponFrom,
                                    nroCouponTo: item?.nroCouponTo,
                                  });
                                  setDetail((prev) => ({
                                    ...prev,
                                    raffleId: item?.raffle?.id,
                                    nroCouponFrom: item?.nroCouponFrom,
                                    nroCouponTo: item?.nroCouponTo,
                                  }));
                                }
                                setOpen(false);
                              }}
                            >
                              {data.type === "proveedor" ? (
                                <>
                                  <TableCell
                                    sx={{
                                      ...cellStyles,
                                      backgroundColor:
                                        i % 2 === 0 ? "#dbdbdb76" : "#dbdbdd12",
                                    }}
                                  >
                                    {item?.game?.name}
                                  </TableCell>
                                  <TableCell
                                    sx={{
                                      ...cellStyles,
                                      backgroundColor:
                                        i % 2 === 0 ? "#dbdbdb76" : "#dbdbdd12",
                                    }}
                                  >
                                    {game?.mode?.id === 2
                                      ? item?.serie
                                      : item?.raffle?.number || item?.number}
                                  </TableCell>
                                  <TableCell
                                    sx={{
                                      ...cellStyles,
                                      backgroundColor:
                                        i % 2 === 0 ? "#dbdbdb76" : "#dbdbdd12",
                                    }}
                                  >
                                    {game?.mode?.id === 2 ? "-" : date}
                                  </TableCell>
                                </>
                              ) : (
                                <>
                                  <TableCell
                                    sx={{
                                      ...cellStyles,
                                      backgroundColor:
                                        i % 2 === 0 ? "#dbdbdb76" : "#dbdbdd12",
                                    }}
                                  >
                                    {item?.game?.name}
                                  </TableCell>
                                  <TableCell
                                    sx={{
                                      ...cellStyles,
                                      backgroundColor:
                                        i % 2 === 0 ? "#dbdbdb76" : "#dbdbdd12",
                                    }}
                                  >
                                    {(item?.nroCouponTo ?? 0) -
                                      (item?.nroCouponFrom ?? 0) +
                                      1}
                                  </TableCell>
                                  <TableCell
                                    sx={{
                                      ...cellStyles,
                                      backgroundColor:
                                        i % 2 === 0 ? "#dbdbdb76" : "#dbdbdd12",
                                    }}
                                  >
                                    {item?.nroCouponFrom} / {item?.nroCouponTo}
                                  </TableCell>
                                  <TableCell
                                    sx={{
                                      ...cellStyles,
                                      backgroundColor:
                                        i % 2 === 0 ? "#dbdbdb76" : "#dbdbdd12",
                                    }}
                                  >
                                    {game?.mode?.id === 2
                                      ? item?.serie
                                      : item?.raffle?.number || item?.number}
                                  </TableCell>
                                  <TableCell
                                    sx={{
                                      ...cellStyles,
                                      backgroundColor:
                                        i % 2 === 0 ? "#dbdbdb76" : "#dbdbdd12",
                                    }}
                                  >
                                    {date}
                                  </TableCell>
                                </>
                              )}
                            </TableRow>
                          </React.Fragment>
                        );
                      })}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Grid>
            ) : (
              <Grid item xs={12} className={s.noresult}>
                {t("noResults")}
                <Button
                  variant="contained"
                  onClick={() => setCreate(true)}
                  sx={{ mt: 10 }}
                >
                  {t("add")}
                </Button>
              </Grid>
            )}
            <Grid
              item
              xs={12}
              sx={{ display: "flex", justifyContent: "center", my: 5 }}
              className={s.pagination}
            >
              <Pagination
                count={totalPages}
                page={page}
                onChange={handlePaginate}
                color="primary"
                disabled={loading}
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Modal>
  );
};

export default ProductosModal;
